import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const customer = window.__HIVE_CUSTOMER__;
const mountNode = document.getElementById("hyman-hive-root");

if (mountNode) {
  const root = createRoot(mountNode);
  root.render(<App customer={customer} />);
}
